import Vue from 'vue'

import GmapCluster from 'vue2-google-maps/dist/components/cluster'
import * as VueGoogleMaps from '@/node_modules/vue2-google-maps'

Vue.use(VueGoogleMaps, {
  load: { key: process.env.NUXT_ENV_VUE_APP_GOOGLE_MAPS_API_KEY }
})
Vue.component('GmapCluster', GmapCluster)
